//#region imports
import { Form } from "devextreme-react";
import { GroupItem, Label, RequiredRule, SimpleItem, Tab, TabPanelOptions, TabbedItem } from "devextreme-react/form";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useAuth } from "../../../../../contexts/auth";
import { leaveTypes, lookupGroups, transferableTypes } from "../../../../../utils/lookup-groups.ts";
import { getPropsLookupExprForIdText, getRadioEditorOptionIdTextVertical } from "../../../../../utils/default-props.js";
import BaseFormWithBreadCrumbs from "../../../../../components/base-form/base-form";
import { useScreenSize } from "../../../../../utils/media-query";
import { useParams } from "react-router-dom";
import { useLookupGroup } from "../../../../../contexts/lookup-group-context.js";
import { LabelRender } from "./leave-label-render.tsx";
import { TargetGroup } from "./leave-target-group";
import { useDataSource } from "../../../../../contexts/dataSource.js";
//#endregion

const radioEditProperties = {
    layout: "horizontal",
    valueExpr: "id",
    displayExpr: "text"
}
const numberEditorOptions = {
    width: 120,
    max: 999,
    min: 1,
    showSpinButtons: true
}
const isPeriodicLeave = (leaveTaype) => {
    return [
        leaveTypes.annualLeave,
        leaveTypes.specialLeave,
        leaveTypes.excuseLeave,
    ].includes(leaveTaype)
}
const isTransferableLeave = (leaveTaype) => {
    return [
        leaveTypes.annualLeave,
        leaveTypes.specialLeave,
        leaveTypes.overtimeLeave,
    ].includes(leaveTaype)
}

function LeaveInfoCard() {

    const [formData, setFormData] = useState(
        {
            name: "",
            leavePaymentTypeId: "", //izin ücret türü
            leaveCalculationMethodId: "", // izin hesaplama metodu id/ günlük saatlik
            duration: 0, //izin süresi
            isPeriodic: false,
            leaveAccrualPeriodTypeId: "", //leavePeriodTypeId: "", //izin hakediş periyot türü, yılbaşında, giriş yıldönümünde                                                              
            advanceLimit: 0, //maxAdvanceTime: 0, // avan limiti            
            maxLimitForSingleUsage: 0, //maxTimeForSingleUsage: 0,
            minLimitForSingleUsage: 0, //minTimeForSingleUsage: 0,
            isDocumentRequired: true, ///isDocumentationRequired: true,
            isStandInEmployeeRequired: false, // isReplacementEmployeeRequired: false, // yedekleme gerekli            
            isAddressRequired: false, //adres gerekli
            isExplanationRequired: true, //açıklama gerekli
            id: "",
            description: "",// izin hakkında bilgi
            leaveTypeId: "",// izin türü, mazeret, yıllık, vs
            isLimited: true, // üzin süresi belirlimi yoksa rapor gibi belirsiz mi?
            minimumEmploymentPeriod: 0, // minimum çalışma süresi,
            leaveAccrualTimeTypeId: "", // izin hakediş zamanı, dönem başı dönem sonu 
            duration5to14: 0,
            duration15toUp: 0,
            durationUnder18: 0,
            durationOver50: 0,
            transferableTypeId: "", //devredilebilir
            maximumTransferAmount: 0, //maksimum devredilecek  miktar
            restrictionPeriodTypeId: "", // kısıtlama periyot türü
            restrictionAmount: 0, // kısıtlama miktarı
            restrictionDurationTypeId: "", //kısıtlama süre türü
            leaveInfoTargetGroups: [],
        }
    )
    const { dataSourceHR } = useDataSource()
    //#region other const
    const params = useParams()
    const screenSize = useScreenSize()
    const formRef = useRef()

    const { activeLanguage } = useAuth()
    const { getLookupData } = useLookupGroup()
    //#endregion

    //#region useStates
    const [leaveId, setLeaveId] = useState(params.id)
    const [readOnly, setReadOnly] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [leavePaymentType, setLeavePaymentType] = useState()
    const [leaveCalculationMethod, setLeaveCalculationMethod] = useState()
    const [leaveAccrualPeriodType, setLeaveAccrualPeriodType] = useState()
    const [leaveType, setLeaveType] = useState()
    const [leaveAccrualTime, setLeaveAccrualTime] = useState()
    const [transferableType, setTransferableType] = useState()
    const [restrictionPeriodType, setRestrictionPeriodType] = useState()
    const [restrictionDurationType, setRestrictionDurationType] = useState()
    const [selectedLeaveType, setSelectedLeaveType] = useState()
    const [isLimitted, setIsLimitted] = useState(formData.isLimitted)
    const [isPeriodic, setIsPeriodic] = useState(formData.isPeriodic)
    const [selectedtransferableId, setSelectedtransferableId] = useState()
    const [leaveInfoTargetGroups, setLeaveInfoTargetGroups] = useState()


    //#endregion

    //#region editProperties
    const leavePaymentTypeEditProperties = useMemo(() => (
        {
            ...radioEditProperties, dataSource: leavePaymentType,
        }), [leavePaymentType]
    )

    const leaveCalculationMethodEditProperties = useMemo(() => (
        {
            ...radioEditProperties,
            dataSource: leaveCalculationMethod,

        }), [leaveCalculationMethod]
    )
    const leaveAccrualPeriodTypeEditorOptions = useMemo(() => (
        {
            ...getRadioEditorOptionIdTextVertical,
            dataSource: leaveAccrualPeriodType,
        }), [leaveAccrualPeriodType]
    )
    const leaveAccrualTimeEditorOption = useMemo(() => (
        {
            ...getRadioEditorOptionIdTextVertical,
            dataSource: leaveAccrualTime,
        }), [leaveAccrualTime]
    )
    const transferableEditorOption = useMemo(() => (
        {
            ...getRadioEditorOptionIdTextVertical,
            dataSource: transferableType,
            onValueChanged: (e) => { setSelectedtransferableId(e.value) }
        }), [transferableType]
    )
    const leaveTypeEditorOption = useMemo(() => (
        {
            ...getPropsLookupExprForIdText,
            dataSource: leaveType,
            onValueChanged: (e) => { setSelectedLeaveType(e.value) }
        }), [leaveType]
    )
    const isPeriodicEditorOption = useMemo(() => (
        {
            onValueChanged: (e) => { setIsPeriodic(e.value) }
        }), []
    )
    const isLimittedEditorOptions = useMemo(() => (
        {
            onValueChanged: (e) => { setIsLimitted(e.value) }
        }), []
    )
    const restrictionPeriodTypeEditorOption = useMemo(() => (
        {
            ...getPropsLookupExprForIdText,
            dataSource: restrictionPeriodType,
        }), [restrictionPeriodType]
    )
    const restrictionDurationTypeEditorOption = useMemo(() => (
        {
            ...getPropsLookupExprForIdText,
            dataSource: restrictionDurationType,
        }), [restrictionDurationType]
    )
 
    const dbAproveHierarchy = useMemo(() => dataSourceHR({
        loadUrl: "/api/ApproveHierarchy"
    }), [dataSourceHR])

    const approveHierarchyEditorOption = useMemo(() => ({
        dataSource: dbAproveHierarchy,
        valueExpr: "id",
        displayExpr: "name"
    }), [dbAproveHierarchy])

    
    //#endregion

    //#region handle events
    const handleFieldDataChanged = (e) => {
        setDirty(true)
    }

    //#endregion

    const onAfterLoadData = (data) => {
        if (data?.leaveInfoTargetGroups)
            setLeaveInfoTargetGroups(data?.leaveInfoTargetGroups)
    }

    useEffect(() => {
        getLookupData(lookupGroups.leavePaymentType).then(response => setLeavePaymentType(response))
        getLookupData(lookupGroups.leaveCalculationMethod).then(response => setLeaveCalculationMethod(response))
        getLookupData(lookupGroups.leaveAccrualPeriodType).then(response => setLeaveAccrualPeriodType(response))

        getLookupData(lookupGroups.leaveType).then(response => setLeaveType(response))
        getLookupData(lookupGroups.leaveAccrualTime).then(response => setLeaveAccrualTime(response))
        getLookupData(lookupGroups.transferableType).then(response => setTransferableType(response))
        getLookupData(lookupGroups.restrictionPeriodType).then(response => setRestrictionPeriodType(response))
        getLookupData(lookupGroups.restrictionDurationType).then(response => setRestrictionDurationType(response))

    }, [activeLanguage, getLookupData])

    useEffect(() => {
        if (formData.id) {
            setLeaveInfoTargetGroups()
        }
    }, [formData])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <BaseFormWithBreadCrumbs
                        formData={formData}
                        setFormData={setFormData}
                        formRef={formRef}
                        readOnly={readOnly}
                        setReadOnly={setReadOnly}
                        dirty={dirty}
                        setDirty={setDirty}
                        //initialValues={{ employeeId: employeeId }}
                        loadId={leaveId}
                        loadUrl={"/api/LeaveInfo/"}
                        updateUrl={"/api/LeaveInfo/FormData"}
                        onAfterLoadData={onAfterLoadData}
                    >
                        <Form
                            width={600}
                            labelLocation={screenSize.isXSmall ? "top" : "left"}
                            formData={formData}
                            readOnly={readOnly}
                            onFieldDataChanged={handleFieldDataChanged}
                            ref={formRef}
                        >
                            <GroupItem>
                                <GroupItem caption="İzin Tanımı">
                                    <SimpleItem dataField='name' editorType="dxTextBox" >
                                        <Label text="İzin Adı" />
                                        <RequiredRule message='İzin adı girilmesi zorunludur.' />
                                    </SimpleItem>
                                    <SimpleItem dataField="description" editorType="dxTextArea">
                                        <Label text="Bilgilendirme Mesajı" />
                                    </SimpleItem>

                                    <SimpleItem dataField="leaveTypeId" editorType="dxSelectBox"
                                        editorOptions={leaveTypeEditorOption}
                                    >
                                        <Label text="İzin Türü" />
                                    </SimpleItem>

                                    <SimpleItem dataField='leavePaymentTypeId' editorType="dxRadioGroup"
                                        editorOptions={leavePaymentTypeEditProperties}
                                    >
                                        <Label text='Ücret Türü' />
                                    </SimpleItem>

                                    <SimpleItem dataField='leaveCalculationMethodId' editorType="dxRadioGroup"
                                        editorOptions={leaveCalculationMethodEditProperties}
                                    >
                                        <Label text='Hesaplama Şekli' />
                                    </SimpleItem>
                                    <SimpleItem dataField="approveHierarchyId" editorType="dxSelectBox"
                                        editorOptions={approveHierarchyEditorOption}
                                    >
                                        <Label text="Onay Hiyerarşisi" />
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem>
                                    <TabbedItem>
                                        <TabPanelOptions deferRendering={true} />
                                        <Tab title="Hakediş">
                                            <GroupItem>
                                                <GroupItem>
                                                    <SimpleItem
                                                        dataField="isLimited"
                                                        editorType="dxCheckBox"
                                                        editorOptions={isLimittedEditorOptions}
                                                    >
                                                        <Label text="Süresi Belirli" />
                                                    </SimpleItem>
                                                    <GroupItem>
                                                        <SimpleItem visible={isLimitted}
                                                            dataField="duration"
                                                            editorType='dxNumberBox'
                                                            editorOptions={numberEditorOptions}
                                                        >
                                                            <Label text="İzin Süresi" />
                                                        </SimpleItem>
                                                    </GroupItem>

                                                    <SimpleItem
                                                        dataField="minimumEmploymentPeriod"
                                                        editorType='dxNumberBox'
                                                        editorOptions={numberEditorOptions}
                                                    >
                                                        <Label text="Minimum Çalışma Süresi(ay)" />
                                                    </SimpleItem>
                                                </GroupItem>

                                                <GroupItem visible={isPeriodicLeave(selectedLeaveType)}
                                                >
                                                    <SimpleItem
                                                        dataField="isPeriodic"
                                                        editorType="dxCheckBox"
                                                        editorOptions={isPeriodicEditorOption}
                                                    >
                                                        <Label text="Periyodik Olarak Hakedilir" />
                                                    </SimpleItem>
                                                    <GroupItem visible={isPeriodic}>
                                                        <SimpleItem
                                                            dataField="leaveAccrualPeriodTypeId"
                                                            editorType="dxRadioGroup"
                                                            editorOptions={leaveAccrualPeriodTypeEditorOptions}
                                                        >
                                                            <Label text="Hakediş Dönemi" />
                                                        </SimpleItem>
                                                        <SimpleItem
                                                            dataField="leaveAccrualTimeTypeId"
                                                            editorType="dxRadioGroup"
                                                            editorOptions={leaveAccrualTimeEditorOption}
                                                        >
                                                            <Label text="Hakediş Zamanı" />
                                                        </SimpleItem>
                                                    </GroupItem>

                                                </GroupItem>

                                                <GroupItem caption="Yıllık İzin Ayarları"
                                                    visible={selectedLeaveType == leaveTypes.annualLeave}
                                                >
                                                    <SimpleItem
                                                        dataField="duration5to14"
                                                        editorType="dxNumberBox"
                                                        editorOptions={numberEditorOptions}
                                                    >
                                                        <Label render={
                                                            LabelRender(
                                                                ["5(dahil) yıldan 15 yıla ",
                                                                    "kadar izin hakkı"])
                                                        } />
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="duration15toUp"
                                                        editorType="dxNumberBox"
                                                        editorOptions={numberEditorOptions}
                                                    >
                                                        <Label render={
                                                            LabelRender(
                                                                ["15(dahil) Yıldan Sonra", "İzin Hakkı"]
                                                            )

                                                        } />
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="durationUnder18"
                                                        editorType="dxNumberBox"
                                                        editorOptions={numberEditorOptions}
                                                    >
                                                        <Label render={
                                                            LabelRender(
                                                                ["18 Yaş ve Altı Çalışan",
                                                                    "(İlk 5 yıllık kıdem süresi için)"]
                                                            )

                                                        } />
                                                    </SimpleItem>
                                                    <SimpleItem
                                                        dataField="durationOver50"
                                                        editorType="dxNumberBox"
                                                        editorOptions={numberEditorOptions}
                                                    >
                                                        <Label render={
                                                            LabelRender(
                                                                ["50 Yaş ve Üstü Çalışan",
                                                                    "(İlk 5 yıllık kıdem süresi için)"]
                                                            )

                                                        } />
                                                    </SimpleItem>

                                                </GroupItem>
                                            </GroupItem>


                                        </Tab >
                                        <Tab title="Devir">
                                            <GroupItem visible={!isTransferableLeave(selectedLeaveType)}>
                                                <div className="dx-tab-text-span" >Kullanılabilecek özellik mevcut değil. </div>
                                            </GroupItem>

                                            <GroupItem visible={isTransferableLeave(selectedLeaveType)} >
                                                <SimpleItem
                                                    dataField="transferableTypeId"
                                                    editorType="dxRadioGroup"
                                                    editorOptions={transferableEditorOption}
                                                >
                                                    <Label text="Sonraki Döneme Devir" />
                                                </SimpleItem>
                                                <GroupItem visible=
                                                    {[transferableTypes.transferPartOfRemaining,
                                                    transferableTypes.transferAllRemaining].includes(selectedtransferableId)}>
                                                    <SimpleItem
                                                        dataField="maximumTransferAmount"
                                                        editorType="dxNumberBox"
                                                        editorOptions={numberEditorOptions}
                                                    >
                                                        <Label text="Maksimum Devredecek Miktar" />
                                                    </SimpleItem>
                                                </GroupItem>

                                            </GroupItem>
                                        </Tab>
                                        <Tab title="Kullanım">
                                            <GroupItem >
                                                <SimpleItem dataField="isExplanationRequired" editorType="dxCheckBox">
                                                    <Label text="Açıklama girmek zorunlu" />
                                                </SimpleItem>
                                                <SimpleItem
                                                    dataField="isDocumentRequired"
                                                    editorType="dxCheckBox">
                                                    <Label text="Belge eklemek zorunlu" />
                                                </SimpleItem>
                                                <SimpleItem dataField="isStandInEmployeeRequired" editorType="dxCheckBox">
                                                    <Label text="Yerine bakacak kişi seçmek zorunlu" />
                                                </SimpleItem>
                                                <GroupItem >
                                                    <SimpleItem dataField="advanceLimit" editorType="dxNumberBox">
                                                        <Label text="Kullanılabilecek avans miktarı" />
                                                    </SimpleItem>
                                                </GroupItem>
                                                <SimpleItem dataField="minLimitForSingleUsage">
                                                    <Label text="Tek seferde minimum miktar" />
                                                </SimpleItem>
                                                <SimpleItem dataField="maxLimitForSingleUsage">
                                                    <Label text="Tek seferde maksimum miktar" />
                                                </SimpleItem>

                                            </GroupItem>
                                            <GroupItem colCount={3} caption="Periyodik Kısıtlama">
                                                <SimpleItem
                                                    dataField="restrictionPeriodTypeId"
                                                    editorType="dxSelectBox"
                                                    editorOptions={restrictionPeriodTypeEditorOption}
                                                >
                                                    <Label location="top" text="Periyot" />
                                                </SimpleItem>
                                                <SimpleItem
                                                    dataField="restrictionAmount" >
                                                    <Label location="top" text="Miktar" />
                                                </SimpleItem>
                                                <SimpleItem
                                                    dataField="restrictionDurationTypeId"
                                                    editorType="dxSelectBox"
                                                    editorOptions={restrictionDurationTypeEditorOption}
                                                >
                                                    <Label location="top" text="Tür" />
                                                </SimpleItem>
                                            </GroupItem>
                                        </Tab>
                                        <Tab title="Hedef Kitle">
                                            <GroupItem >
                                                <TargetGroup
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                    setDirty={setDirty}
                                                    readOnly={readOnly}
                                                />
                                            </GroupItem>
                                        </Tab>
                                    </TabbedItem>
                                </GroupItem>
                            </GroupItem>
                        </Form>
                    </BaseFormWithBreadCrumbs>
                </div>
            </div>
        </React.Fragment>
    )
}

export default LeaveInfoCard
